export const handleScroll = (sectionId: string, offset: number = 120) => {
    const section = document.getElementById(sectionId);
    if (section) {
        const  elementPosition = section.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth',
        })
    }
};